import http from "@/http"

export default {
    install(Vue,option){
        Vue.prototype.$http=http
    }
}